__turbopack_context__.v({
  "className": "libre_caslon_text_f39dd763-module__2tGcnW__className",
  "variable": "libre_caslon_text_f39dd763-module__2tGcnW__variable",
});
